import { render, staticRenderFns } from "./IncreaseNumber.vue?vue&type=template&id=dfed01de&"
import script from "./IncreaseNumber.vue?vue&type=script&lang=js&"
export * from "./IncreaseNumber.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('dfed01de')) {
      api.createRecord('dfed01de', component.options)
    } else {
      api.reload('dfed01de', component.options)
    }
    module.hot.accept("./IncreaseNumber.vue?vue&type=template&id=dfed01de&", function () {
      api.rerender('dfed01de', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2UNeZ49iqPoqd/JS/comp/IncreaseNumber.vue"
export default component.exports